import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';
import _imports_1 from '@/assets/imgs/ic_del_2.png';
import _imports_2 from '@/assets/imgs/ic_del1.png';
import _imports_3 from '@/assets/imgs/ic_add1.png';
import _imports_4 from '@/assets/imgs/add_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-ef02e9da"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "theme-setting-warp"
};
const _hoisted_2 = {
  class: "cms-card-block table-warp"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = ["onDblclick"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "select_container"
};
const _hoisted_12 = {
  class: "item_container"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));

const _hoisted_16 = {
  class: "cms-module-title mg-t--15"
};
const _hoisted_17 = {
  class: "upload--tip mg-b--15"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload__icon",
  src: _imports_4,
  alt: ""
}, null, -1));

const _hoisted_19 = {
  class: "mg-b--10"
};
const _hoisted_20 = ["src"];
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import UploadImage from '../../Components/UploadImage/index.vue';
import { inject, ref, watch, nextTick } from 'vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { messageBox } from '@/utils/validate';
import { StatusOptions } from '@/assets/config/dicts';
import { clearData, debounce, getItemByProp, removePropertyOfNull } from '@/utils/tools';
import { elMessage } from '@/utils';
import { getOperationPlanThemeApi, getThemesLangaugeListApi, editOperationPlanBusinessThemeApi, editOperationPlanBusinessThemesApi, addOperationPlanBusinessThemeApi, deleteOperationPlanBusinessThemeApi, getLangOptionsApi } from '@/api/vodNew';
import draggable from "vuedraggable";
import { ElMessage } from 'element-plus';
import { getDynamicPlanThemeApi, updateDynamicPlanThemeApi } from '@/api/topic';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'uploadPlanTheme'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const aoeFormRef = ref(null);
    const imageItemRef = ref(null);
    const showUploadImage = ref(false);
    const langOptions = ref([]);
    const countriesList = inject('countriesList');
    const tooltipContent = ref(t('快速双击排序序号,在输入框编辑排序')); // headerConfig

    const headerConfig = ref({
      title: '主题设置',
      btnList: [{
        label: '返回',
        func: () => {
          emit('update:modelValue', false);
          emit('uploadPlanTheme');
        }
      }]
    }); // tableConfig

    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      showPageBar: false,
      paginationConfig: usePageConfig(),
      // isShowHeader: false,
      config: {
        loading: false
      },
      rowKey: 'serialId'
    }); // 获取主题的多语言列表

    const getThemesLangaugeList = async id => {
      const {
        code,
        data
      } = await getThemesLangaugeListApi(id);

      if (code == 0) {
        return data ? data.map(item => {
          return { ...item,
            id
          };
        }) : [{
          language: 'en',
          name: '',
          id
        }];
      } else {
        return [{
          language: 'en',
          name: '',
          id
        }];
      }
    }; // 回显上传图片url


    const urlStr = ref('');
    const columnConfig = reactive({
      columnList: [{
        label: '序号',
        prop: 'serial',
        width: 70
      }, {
        label: '主题名称',
        prop: 'operationThemeName',
        width: 160
      }, {
        label: '主题类型',
        prop: 'type',
        width: 120,
        formatter: value => {
          return value === 'fixed' ? t('固定') : t('运营');
        }
      }, {
        label: '排序',
        prop: 'sequence',
        cellSlot: true,
        width: 90
      }, {
        label: '状态',
        prop: 'status',
        width: 100,
        formatter: value => {
          if (value != undefined && value != null) {
            //console.log('状态', value, STATUS_FIELD)
            return `<span style="color: ${STATUS_FIELD[value].color}">${STATUS_FIELD[value].value}</span>`;
          }
        }
      }, {
        label: '终端审核',
        prop: 'terminalCheck',
        width: 100,
        cellSlot: true
      }, {
        label: '运营国家',
        prop: 'region',
        width: 100,
        formatter: val => val == 'All' || !val ? t('不限') : val
      }, {
        label: '执行周期',
        prop: 'executionTime',
        width: 210
      }, {
        label: '背景图',
        prop: 'backgroundImgUrl',
        cellSlot: true,
        width: 160,
        showOverflowTooltip: false
      }, {
        label: '备注',
        prop: 'remark'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        showOverflowTooltip: false,
        buttonsList: [{
          label: '执行',
          func: debounce(row => {
            messageBox('确定执行该主题?').then(async () => {
              try {
                const {
                  id
                } = row;
                const {
                  type
                } = currentVodPlusItem.value;
                let putData = {
                  id,
                  status: 'running'
                };
                const res = type === 'static' ? await editOperationPlanBusinessThemeApi(putData) : await updateDynamicPlanThemeApi(putData);

                if (res.code == '0') {
                  elMessage('success', '操作成功');
                  getOperationPlanTheme();
                }
              } catch (error) {}
            });
          }, 200),
          controller: row => {
            return row.status !== 'running' ? true : false;
          }
        }, {
          label: '停运',
          func: debounce(row => {
            messageBox('确定停运该主题?').then(async () => {
              try {
                const {
                  id
                } = row;
                const {
                  type
                } = currentVodPlusItem.value;
                let putData = {
                  id,
                  status: 'end'
                };
                const res = type === 'static' ? await editOperationPlanBusinessThemeApi(putData) : await updateDynamicPlanThemeApi(putData);

                if (res.code == '0') {
                  elMessage('success', '操作成功');
                  getOperationPlanTheme();
                }
              } catch (error) {}
            });
          }, 200),
          controller: row => {
            return row.status === 'running' ? true : false;
          }
        }, {
          label: '编辑',
          func: async row => {
            console.log('233-row', row);
            const {
              type
            } = row;

            if (type === 'fixed') {
              actionForm.action = 'area';
              actionForm.areaFormData = { ...row
              };
            } else if (type === 'operational') {
              // 运营
              actionForm.formData = { ...row
              };

              if (!row.isParent) {
                isChildDialog.value = true; // 从接口获取对应主题的多语言列表

                actionForm.formData.names = await getThemesLangaugeList(row.id);
              }

              actionForm.formData.time = [row.scheduleStartTime == '0000-00-00 00:00:00' ? '' : row.scheduleStartTime, row.scheduleEndTime == '0000-00-00 00:00:00' ? '' : row.scheduleEndTime];
              actionForm.action = !row.isParent ? 'edit' : 'edit-parent';
              actionForm.formData.parentId = row.parentThemeId;
              urlStr.value = row.backgroundImage || '';
              actionForm.formData.backgroundImgUrl = row.backgroundImage;
            }

            actionForm.dialogConfig.title = '编辑';
            actionForm.visible = true;
          }
        }, {
          label: '复制',
          func: async row => {
            // console.log('复制',row)
            isChildDialog.value = true;
            actionForm.formData = { ...row
            };
            actionForm.formData.time = [row.scheduleStartTime == '0000-00-00 00:00:00' ? '' : row.scheduleStartTime.split(' ')[0], row.scheduleEndTime == '0000-00-00 00:00:00' ? '' : row.scheduleEndTime.split(' ')[0]];
            actionForm.formData.sequence = ''; // 从接口获取对应主题的多语言列表

            actionForm.formData.names = await getThemesLangaugeList(row.id);
            actionForm.formData.parentId = row.parentThemeId;
            actionForm.imgUrl = row.backgroundImage;
            actionForm.formData.backgroundImgUrl = row.backgroundImage;
            actionForm.action = 'copy';
            actionForm.dialogConfig.title = '复制主题';
            actionForm.visible = true;
          },
          controller: row => {
            return !row.isParent;
          }
        }, {
          label: '添加主题',
          func: row => {
            isChildDialog.value = true;
            clearData(actionForm.formData);
            actionForm.formData.names = [{
              language: 'en',
              name: '',
              id: row.id
            }];
            actionForm.formData.status = 'waiting';
            actionForm.formData.parentId = row.id;
            actionForm.dialogConfig.title = '添加主题';
            actionForm.action = 'add';
            actionForm.visible = true;
            urlStr.value = '';
          },
          controller: row => {
            const {
              type
            } = currentVodPlusItem.value;
            return row.type == 'operational' && row.isParent && type === 'static';
          }
        }, {
          label: '删除',
          func: row => {
            const {
              id
            } = row;
            messageBox('确定删除所选数据吗?').then(async () => {
              const {
                code
              } = await deleteOperationPlanBusinessThemeApi({
                operationPlanBusinessThemeId: id
              });

              if (code == '0') {
                elMessage('success', '删除成功');
                getOperationPlanTheme();
              }
            });
          },
          controller: row => {
            return !row.isParent && row.status !== 'running';
          }
        }]
      }]
    }); // 校验排序

    const validatorSequence = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入排序')));
      } else if (value && value.length > 4) {
        callback(new Error(t('限制字符数量', {
          num: 4
        })));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else {
        callback();
      }
    }; // 是否为子级点击的编辑/复制弹窗


    const isChildDialog = ref(false);

    const validNames = (rule, value, callback) => {
      let emptyOption = value.map(item => {
        if (item.name === '') {
          return 'nameError';
        }

        if (item.language === '') {
          return 'langError';
        }
      });
      if (emptyOption.indexOf('nameError') > -1) return callback(new Error(t(`请输入主题名称`)));
      if (emptyOption.indexOf('langError') > -1) return callback(new Error(t(`请选择语言`)));
      callback();
    }; // 新增编辑model


    const actionForm = reactive({
      visible: false,
      action: 'add',
      // 预览图片路径
      imgUrl: '',
      formList: [[{
        label: '主题名称',
        prop: 'names',
        widgetType: 'input',
        required: true,
        itemSlot: true //maxlength: 100, showWordLimit: true

      }, {
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        translation: true,
        list: StatusOptions,
        required: true
      }], [{
        label: '排序',
        prop: 'sequence',
        widgetType: 'input',
        type: 'number',
        required: true,
        controller: val => {
          return !isChildDialog.value;
        },
        input: val => {
          if (val > tableConfig.data.length) {
            actionForm.formData.sequence = String(tableConfig.data.length);
          }
        }
      }, {
        label: '时间设置',
        prop: 'time',
        widgetType: 'date',
        required: true,
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange'
      }, // 兼容运营主题子运营主题下无排序的显示
      {
        label: '运营国家',
        prop: 'region',
        widgetType: 'Select',
        list: [],
        required: true,
        valueKey: 'label',
        func: val => {
          aoeFormRef.value.mForm.validateField('region');
        },
        controller: val => {
          return isChildDialog.value;
        }
      }], [{
        label: '运营国家',
        prop: 'region',
        widgetType: 'Select',
        list: [],
        required: true,
        valueKey: 'label',
        func: val => {
          aoeFormRef.value.mForm.validateField('region');
        },
        controller: val => {
          return !isChildDialog.value;
        }
      }, {
        label: '备注',
        prop: 'remark',
        widgetType: 'input',
        controller: (val, configData, config) => {
          isChildDialog.value ? config.colspan = 3 : '';
          return true;
        }
      }]],
      formData: {
        parentId: '',
        names: [{
          language: 'en',
          name: '',
          id: 1
        }],
        status: 'waiting',
        sequence: '',
        time: [],
        region: '',
        remark: '',
        backgroundImgFile: [],
        backgroundImgUrl: '',
        backgroundImage: ''
      },
      areaFormList: [[{
        label: '运营国家',
        prop: 'region',
        widgetType: 'Select',
        valueKey: 'label',
        list: [],
        required: true,
        func: val => {
          aoeFormRef.value.mForm.validateField('region');
        }
      }]],
      areaFormData: {
        id: '',
        region: ''
      },
      parentFormList: [[{
        label: '主题名称',
        prop: 'operationThemeName',
        widgetType: 'text',
        required: true,
        maxlength: 100,
        showWordLimit: true
      }, {
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        translation: true,
        list: StatusOptions,
        required: true
      }], [{
        label: '备注',
        prop: 'remark',
        widgetType: 'input',
        colspan: 6 // controller: (val, configData, config) => {
        //     isChildDialog.value ? config.colspan = 3 : '';
        //     return true;
        // }

      }]],
      dialogConfig: {
        title: '新增',
        destroyOnClose: true
      },
      rules: {
        names: [{
          required: true,
          validator: validNames
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }],
        sequence: [{
          required: true,
          trigger: 'blur',
          validator: validatorSequence
        }],
        time: [{
          required: true,
          message: t('请选择时间'),
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: t('请选择运营国家'),
          trigger: 'blur'
        }]
      },
      fileOnChange: file => {
        // 预览图片
        let reader = new FileReader(); //转base64

        reader.onload = function (e) {
          //将图片路径赋值给src
          actionForm.imgUrl = e.target.result;
        };

        reader.readAsDataURL(file.raw);
      },
      confirm: done => {
        if (actionForm.action == 'add' || actionForm.action == 'copy') {
          addOperationPlanBusinessTheme(done);
        } else if (actionForm.action == 'edit') {
          editOperationPlanBusinessTheme(done);
        } else if (actionForm.action == 'area') {
          editAreaOperationPlanBusinessTheme(done);
        } else if (actionForm.action == 'edit-parent') {
          editPrarentOperationPlanBusinessTheme(done);
        }
      }
    });
    const currentVodPlusItem = inject('currentVodPlusItem');
    const STATUS_FIELD = inject('STATUS_FIELD');

    const getOperationPlanTheme = async () => {
      tableConfig.config.loading = true;

      try {
        const {
          id,
          type
        } = currentVodPlusItem.value;
        const res = type === 'static' ? await getOperationPlanThemeApi({
          vodplusOperatePlanId: id
        }) : await getDynamicPlanThemeApi({
          vodplusOperatePlanId: id
        });

        if (res.code == '0') {
          tableConfig.data = setSerial(res.data);
        }
      } catch (error) {
        console.log(error);
      }

      tableConfig.config.loading = false;
    };

    const setSerial = list => {
      if (list != null && list.length > 0) {
        list = list.map((item, index) => {
          item.serial = index + 1;
          item.serialId = index + 1;
          item.isParent = true;
          item.sortMax = list.length;
          item.operationThemeName = item.name; //item.operationThemeName = [{language: 'en', name: item.name, id: item.id}]

          item.executionTime = item.scheduleStartTime == '0000-00-00 00:00:00' && item.scheduleEndTime == '0000-00-00 00:00:00' ? t('不限') : [item.scheduleStartTime + '~' + item.scheduleEndTime];

          if (item.businessThemeList != null && item.businessThemeList.length > 0) {
            item = { ...item,
              children: setChildSerial(item.businessThemeList, item)
            };
          }

          return item;
        });
        return list;
      } else {
        return list;
      }
    };

    const setChildSerial = (list, parentItem) => {
      if (list != null && list.length > 0) {
        list = list.map((item, index) => {
          item.serial = index + 1;
          item.serialId = parentItem.serialId + '.' + (index + 1);
          item.sortMax = list.length;
          item.sequence = index + 1;
          item.operationThemeName = item.name; //item.operationThemeName = [{language: 'en', name: item.name, id: item.id}]

          item.executionTime = item.scheduleStartTime == '0000-00-00 00:00:00' && item.scheduleEndTime == '0000-00-00 00:00:00' ? t('不限') : [item.scheduleStartTime + '~' + item.scheduleEndTime];

          if (item.businessThemeList) {
            item.children = setChildSerial(item.businessThemeList, item);
          }

          return item;
        });
        return list;
      } else {
        return list;
      }
    }; // 终端审核 switch 按钮 Change点击事件


    const handleSwitchChange = row => {
      tableConfig.config.loading = true;
      return new Promise(async (resolve, reject) => {
        try {
          const {
            id
          } = row;
          const {
            type
          } = currentVodPlusItem.value;
          let putData = {
            id,
            terminalCheck: row.terminalCheck == 'uncheck' ? 'checked' : 'uncheck'
          };
          const res = type === 'static' ? await editOperationPlanBusinessThemeApi(putData) : await updateDynamicPlanThemeApi(putData);

          if (res.code == '0') {
            setTimeout(() => {
              elMessage('success', '操作成功');
              getOperationPlanTheme();
              return resolve(true);
            }, 200);
          } else {
            setTimeout(() => {
              tableConfig.config.loading = false;
              return reject(false);
            }, 200);
          }
        } catch (error) {
          setTimeout(() => {
            elMessage('error', '');
            tableConfig.config.loading = false;
            return reject(false);
          }, 200);
        }
      });
    };

    const editCell = ref('');

    const onEditCell = scope => {
      editCell.value = `${scope.$index}-${scope.column.sequence}`;
      nextTick(() => {
        const input = document.querySelector('.EL__focus .el-input__inner');
        input.focus();
      });
    }; // 修改排序输入框获取焦点事件


    const onSIndexFocus = row => {
      // 因为编辑时会改变之前的 index，所以要记住之前的 index
      tableConfig.oldIndex = row.sequence;
    };

    const onInput = (val, row) => {
      row.sequence = val.replace(/[^\d]/g, '');

      if (val > row.sortMax) {
        row.sequence = row.sortMax;
      }
    }; // 修改排序输入框丢失焦点事件


    const onSIndexBlur = async row => {
      console.log('currentVodPlusItem.value', currentVodPlusItem.value);
      console.log('row', row);
      let no = row.sequence;

      if (no === '' || no === 0) {
        row.sequence = tableConfig.oldIndex;
        editCell.value = '';
      } else if (row.sequence !== tableConfig.oldIndex) {
        try {
          const {
            id
          } = row;
          const {
            type
          } = currentVodPlusItem.value;
          let putData = {
            id,
            sequence: row.sequence
          };
          const res = type === 'static' ? await editOperationPlanBusinessThemeApi(putData) : await updateDynamicPlanThemeApi(putData);

          if (res.code == '0') {
            elMessage('success', '修改成功');
            getOperationPlanTheme();
          }

          editCell.value = '';
        } catch (error) {
          elMessage('error', '系统错误');
          row.sequence = tableConfig.oldIndex;
          editCell.value = '';
        }
      } else {
        editCell.value = '';
      }
    };

    const onUploadImageComfirm = (params, done) => {
      const {
        type,
        base64Image,
        url,
        file
      } = params;
      console.log('581-type', type); // 0 输入URL

      if (type == 0) {
        actionForm.formData.backgroundImgUrl = url;
      } // 1 上传图片
      else {
        actionForm.formData.backgroundImgUrl = base64Image;
        actionForm.formData.backgroundImgFile = [file];
      }

      nextTick(() => {
        imageItemRef.value.validateField('backgroundImgUrl');
      });
      done();
    };

    const addOperationPlanBusinessTheme = async done => {
      Promise.all([aoeFormRef.value.mForm.validate(), imageItemRef.value.validate()]).then(async valid => {
        if (valid) {
          try {
            let params = { ...actionForm.formData,
              scheduleStartTime: actionForm.formData.time[0],
              scheduleEndTime: actionForm.formData.time[1] // terminalCheck: 0

            };

            if (actionForm.formData.backgroundImgFile && actionForm.formData.backgroundImgFile.length) {
              delete params.backgroundImgUrl;
            } else {
              delete params.backgroundImgFile;
            }

            if (actionForm.formData.region == t('不限')) params.region = 'All';
            if (actionForm.action == 'copy') delete params.id;
            delete params.time;
            params = removePropertyOfNull(params);
            const {
              code,
              data
            } = await addOperationPlanBusinessThemeApi(params);

            if (code == '0') {
              elMessage('success', '新增成功');
              actionForm.visible = false;
              done();
              getOperationPlanTheme();
            } else {
              done();
            }
          } catch (error) {
            console.log(error);
            done();
          }
        }
      }).catch(() => {
        done();
      });
    };

    const editPrarentOperationPlanBusinessTheme = async done => {
      aoeFormRef.value.mForm.validate(async valid => {
        if (valid) {
          try {
            let params = { ...actionForm.formData,
              scheduleStartTime: actionForm.formData.time[0],
              scheduleEndTime: actionForm.formData.time[1]
            };

            if (actionForm.formData.backgroundImgFile && actionForm.formData.backgroundImgFile.length) {
              delete params.backgroundImgUrl;
            } else {
              delete params.backgroundImgFile;
            }

            delete params.time;
            params = removePropertyOfNull(params);
            const {
              code,
              data
            } = await editOperationPlanBusinessThemesApi(params);

            if (code == '0') {
              elMessage('success', '修改成功');
              actionForm.visible = false;
              done();
              getOperationPlanTheme();
            } else {
              done();
            }
          } catch (error) {
            console.log(error);
            done();
          }
        } else {
          done();
        }
      });
    };

    const editOperationPlanBusinessTheme = async done => {
      Promise.all([aoeFormRef.value.mForm.validate(), imageItemRef.value.validate()]).then(async valid => {
        if (valid) {
          try {
            let params = { ...actionForm.formData,
              scheduleStartTime: actionForm.formData.time[0],
              scheduleEndTime: actionForm.formData.time[1]
            };

            if (actionForm.formData.backgroundImgFile && actionForm.formData.backgroundImgFile.length) {
              delete params.backgroundImgUrl;
            } else {
              delete params.backgroundImgFile;
            }

            delete params.time;
            params = removePropertyOfNull(params);
            const {
              code,
              data
            } = await editOperationPlanBusinessThemesApi(params);

            if (code == '0') {
              elMessage('success', '修改成功');
              actionForm.visible = false;
              done();
              getOperationPlanTheme();
            } else {
              done();
            }
          } catch (error) {
            console.log(error);
            done();
          }
        }
      }).catch(() => {
        done();
      });
    };

    const editAreaOperationPlanBusinessTheme = async done => {
      aoeFormRef.value.mForm.validate(async valid => {
        if (valid) {
          try {
            const {
              type
            } = currentVodPlusItem.value;
            let params = {
              id: actionForm.areaFormData.id,
              region: actionForm.areaFormData.region
            };
            const {
              code,
              data
            } = type === 'static' ? await editOperationPlanBusinessThemeApi(params) : await updateDynamicPlanThemeApi(params);

            if (code == '0') {
              elMessage('success', '修改成功');
              actionForm.visible = false;
              done();
              getOperationPlanTheme();
            } else {
              done();
            }
          } catch (error) {
            console.log(error);
            done();
          }
        } else {
          done();
        }
      });
    }; // 获取语言列表


    const getLangOptions = async () => {
      // 获取过一次直接存储
      if (sessionStorage.getItem('themeLangOptions')) {
        return langOptions.value = JSON.parse(sessionStorage.getItem('themeLangOptions'));
      }

      const {
        code,
        data
      } = await getLangOptionsApi();

      if (code == 0) {
        langOptions.value = data ? data : [];
        sessionStorage.setItem('themeLangOptions', JSON.stringify(data));
      }
    };

    const nameId = ref(7);

    const onAddNames = () => {
      if (actionForm.formData.names.length >= 6) return ElMessage({
        type: 'warning',
        message: t('最多添加六种语言')
      });
      nameId.value++;
      actionForm.formData.names.push({
        name: '',
        language: '',
        id: nameId.value
      }); // 单独校验字幕

      aoeFormRef.value.mForm.validateField('names');
    };

    const onDelNames = id => {
      actionForm.formData.names = actionForm.formData.names.filter((item, i) => item.id !== id); // 单独校验字幕

      aoeFormRef.value.mForm.validateField('names');
    };

    watch(() => props.modelValue, async val => {
      if (val) {
        await getLangOptions();
        let item = getItemByProp(actionForm.formList, 'region');
        let item2 = getItemByProp(actionForm.areaFormList, 'region');
        item.list = countriesList.value;
        item2.list = countriesList.value;
        actionForm.formList[2][0].list = countriesList.value;
        getOperationPlanTheme();
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => actionForm.visible, val => {
      if (val) {
        nextTick(() => {
          aoeFormRef.value && aoeFormRef.value.mForm.resetFields();
          imageItemRef.value && imageItemRef.value.resetFields();
        });
      } else {
        isChildDialog.value = false;
      }
    });

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_input = _resolveComponent("el-input");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_m_dialog = _resolveComponent("m-dialog");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_common_table, {
        "show-title": false,
        "option-column-list": columnConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: () => '',
        options: tableConfig.config
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: tooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property === 'backgroundImgUrl' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [scope.row.backgroundImage ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            placement: "bottom-start",
            width: 150,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("img", {
              class: "logo",
              src: scope.row.backgroundImage,
              alt: ""
            }, null, 8, _hoisted_5)]),
            default: _withCtx(() => [_createElementVNode("img", {
              style: {
                "width": "130px",
                "display": "inline-block",
                "text-align": "center"
              },
              src: scope.row.backgroundImage,
              alt: ""
            }, null, 8, _hoisted_6)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)], 64)) : scope.column.property === 'terminalCheck' ? (_openBlock(), _createBlock(_component_el_switch, {
            key: 1,
            modelValue: scope.row.terminalCheck,
            "onUpdate:modelValue": $event => scope.row.terminalCheck = $event,
            disabled: scope.row.status == 'running',
            "before-change": () => handleSwitchChange(scope.row),
            "active-value": 'checked',
            "inactive-value": 'uncheck'
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "before-change"])) : _createCommentVNode("", true), scope.column.property === 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [scope.row.isParent ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [editCell.value != `${scope.$index}-${scope.column.sequence}` ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: {
              "display": "inline-block",
              "width": "100%"
            },
            class: "pointer",
            onDblclick: $event => onEditCell(scope)
          }, _toDisplayString(scope.row.sequence), 41, _hoisted_8)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            maxlength: "6",
            class: "EL__focus",
            modelValue: scope.row.sequence,
            "onUpdate:modelValue": $event => scope.row.sequence = $event,
            modelModifiers: {
              number: true
            },
            placeholder: _ctx.$t('请输入序号'),
            onFocus: $event => onSIndexFocus(scope.row),
            onInput: val => onInput(val, scope.row),
            onBlur: $event => onSIndexBlur(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onFocus", "onInput", "onBlur"]))], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(scope.row.sequence), 1))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "render", "options"])]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: actionForm.action === 'area' ? '600px' : '70%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [actionForm.action === 'add' || actionForm.action === 'edit' || actionForm.action === 'copy' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          ref_key: "aoeFormRef",
          ref: aoeFormRef,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop == 'names' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(draggable), {
                list: actionForm.formData.names,
                handle: ".move",
                animation: "300",
                onStart: _ctx.onStart,
                onEnd: _ctx.onEnd
              }, {
                item: _withCtx(({
                  element
                }) => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_select, {
                  modelValue: element.language,
                  "onUpdate:modelValue": $event => element.language = $event,
                  style: {
                    "margin-right": "5px"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.nativeName,
                      value: item.code
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
                  modelValue: element.name,
                  "onUpdate:modelValue": $event => element.name = $event,
                  style: {
                    "margin-right": "5px"
                  }
                }, null, 8, ["modelValue", "onUpdate:modelValue"]), actionForm.formData.names.length === 1 ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "info",
                  disabled: "",
                  style: {
                    "width": "36px"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_13]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  color: "#fdeded",
                  onClick: $event => onDelNames(element.id),
                  style: {
                    "width": "36px"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_14]),
                  _: 2
                }, 1032, ["onClick"])), _createVNode(_component_el_button, {
                  color: "#e9f4fc",
                  onClick: onAddNames,
                  style: {
                    "width": "36px"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_15]),
                  _: 1
                })])]),
                _: 2
              }, 1032, ["list", "onStart", "onEnd"])])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data", "rules"]), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('上传图片')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('温馨提示：图片大小建议在500KB以内。')), 1), _createVNode(_component_el_form, {
          model: actionForm.formData,
          ref_key: "imageItemRef",
          ref: imageItemRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            class: "upload-form-item",
            prop: "backgroundImgUrl"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
              class: "upload--img pointer",
              onClick: _cache[0] || (_cache[0] = $event => showUploadImage.value = true)
            }, [_hoisted_18, _createElementVNode("footer", null, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('主题背景图')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('尺寸')) + "：1920*1080px", 1)])], 512), [[_vShow, !actionForm.formData.backgroundImgUrl]]), _withDirectives(_createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = $event => showUploadImage.value = true),
              class: "pointer upload--img no--border"
            }, [_createElementVNode("img", {
              class: "prev--img",
              src: actionForm.formData.backgroundImgUrl,
              alt: ""
            }, null, 8, _hoisted_20)], 512), [[_vShow, actionForm.formData.backgroundImgUrl]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])], 64)) : _createCommentVNode("", true), actionForm.action === 'area' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 1,
          ref_key: "aoeFormRef",
          ref: aoeFormRef,
          "form-list": actionForm.areaFormList,
          "form-data": actionForm.areaFormData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"])) : _createCommentVNode("", true), actionForm.action === 'edit-parent' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 2,
          col: ['20%', '30%', '20%', '30%'],
          ref_key: "aoeFormRef",
          ref: aoeFormRef,
          "form-list": actionForm.parentFormList,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "nativeConfig", "onOnConfirm"]), _createVNode(UploadImage, {
        modelValue: showUploadImage.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showUploadImage.value = $event),
        "url-str": urlStr.value,
        onOnComfirm: onUploadImageComfirm
      }, null, 8, ["modelValue", "url-str"])])) : _createCommentVNode("", true);
    };
  }

});